// Application Routes
export const ROUTES = {
  // Public routes
  LOGIN: '/',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',

  // App routes (protected)
  APP: '/app',
  DASHBOARD: '/app/dashboard',

  // Clients
  CLIENTS: '/app/clients',
  CLIENT_DETAIL: (id: number | string) => `/app/clients/${id}`,

  // Matters
  MATTERS: '/app/matters',
  MATTER_DETAIL: (id: number | string) => `/app/matters/${id}`,

  // Contracts
  CONTRACTS: '/app/contracts',
  CONTRACT_DETAIL: (id: number | string) => `/app/contracts/${id}`,

  // Billing
  TIME_ENTRIES: '/app/time-entries',
  INVOICES: '/app/invoices',
  INVOICE_DETAIL: (id: number | string) => `/app/invoices/${id}`,

  // Calendar
  CALENDAR: '/app/calendar',

  // Reports
  REPORTS: '/app/reports',

  // Settings
  SETTINGS: '/app/settings',
  SETTINGS_COMPANY: '/app/settings/company',
  SETTINGS_BILLING: '/app/settings/billing',
  SETTINGS_USERS: '/app/settings/users',

  // Errors
  NOT_FOUND: '/404',
  FORBIDDEN: '/403',
} as const;
